import { useStore } from "../store.js";
import { X } from "./Icons.js";

interface Props {
  onClose: () => void;
}

export function TweaksPanel({ onClose }: Props) {
  const { theme, lang, audio, setTheme, setLang, setAudio, setGF } = useStore();

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
        width: 260,
        background: "var(--bg-elevated)",
        border: "1px solid var(--line-strong)",
        borderRadius: "var(--radius-lg)",
        padding: 14,
        zIndex: 100,
        boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 10,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "var(--ink-2)",
            fontWeight: 600,
          }}
        >
          Tweaks
        </div>
        <button className="btn-icon" onClick={onClose}>
          <X size={12} />
        </button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div>
          <div className="field-label" style={{ marginBottom: 6 }}>
            Theme
          </div>
          <div className="seg">
            <button
              className={theme === "dark" ? "on" : ""}
              onClick={() => setTheme("dark")}
            >
              ◐ Dark
            </button>
            <button
              className={theme === "light" ? "on" : ""}
              onClick={() => setTheme("light")}
            >
              ◑ Light
            </button>
          </div>
        </div>
        <div>
          <div className="field-label" style={{ marginBottom: 6 }}>
            Language
          </div>
          <div className="seg">
            <button className={lang === "fr" ? "on" : ""} onClick={() => setLang("fr")}>
              Français
            </button>
            <button className={lang === "en" ? "on" : ""} onClick={() => setLang("en")}>
              English
            </button>
          </div>
        </div>
        <div>
          <div className="field-label" style={{ marginBottom: 6 }}>
            {lang === "fr" ? "Bips audio (aperçu)" : "Audio cues (preview)"}
          </div>
          <div className="seg">
            <button className={!audio ? "on" : ""} onClick={() => setAudio(false)}>
              Off
            </button>
            <button className={audio ? "on" : ""} onClick={() => setAudio(true)}>
              On 🔔
            </button>
          </div>
        </div>
        <div>
          <div className="field-label" style={{ marginBottom: 6 }}>
            GF presets
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <button className="btn btn-ghost" onClick={() => setGF(30, 80)}>
              30/80
            </button>
            <button className="btn btn-ghost" onClick={() => setGF(40, 85)}>
              40/85
            </button>
            <button className="btn btn-ghost" onClick={() => setGF(20, 70)}>
              20/70
            </button>
            <button className="btn btn-ghost" onClick={() => setGF(50, 90)}>
              50/90 ⚠
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
